export default {
  path: '/general/providers-without-visit-registry',
  component: () =>
    import('@/views/dashboard/providers-without-visit-registry/Wrapper.vue'),
  children: [
    {
      path: '',
      name: 'providers-without-visit-registry',
      component: () =>
        import('@/views/dashboard/providers-without-visit-registry/Main.vue'),
    },
  ],
}
